import {
  IEcgRecordingApi,
  IRawEcgWaveform,
  IRawEcgWaveformDevice,
} from "../@types/Ecg";
import { api } from "./api";

export const ecgService = {
  // Lists a patient's ECG recordings (metadata only), newest first. Optional
  // `fromDate`/`toDate` (YYYY-MM-DD) filter the range server-side.
  async getPatientEcgRecordings(
    patientId: number,
    fromDate?: string,
    toDate?: string
  ): Promise<IEcgRecordingApi[]> {
    const response = await api.get<IEcgRecordingApi[]>(
      `/Portal/AliveCorEcg/Patient/${patientId}`,
      { params: { fromDate, toDate } }
    );

    return response.data;
  },

  // Fetches the waveform samples for a single recording. The API proxies the
  // artifact server-side and returns the JSON directly, so this is a normal
  // authenticated, same-origin call (no S3 / CORS / pre-signed URLs involved).
  // The payload may be the on-device recorder format (the current standard) or
  // the older SDK format; both are normalized downstream by parseEcgData.
  async getEcgWaveform(
    recordingId: string
  ): Promise<IRawEcgWaveform | IRawEcgWaveformDevice> {
    const response = await api.get<IRawEcgWaveform | IRawEcgWaveformDevice>(
      `/Portal/AliveCorEcg/Recording/${recordingId}/Waveform`
    );

    return response.data;
  },
};
